import React, { useEffect, useMemo, useContext } from 'react';
import { Spinner } from '../../StyledComponent';
import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';
import { ReactComponent as AlertIcon } from '../../../assets/novosicones/Financeiro/warning_amber_black_24dp.svg';
import Alert from './alert';
import Paginacao from '../../Paginacao';
import Format from '../../../Utils/formatCurrent';

import './styles.scss';

const ParcelasPagas = ({
  parcelasPagas,
  loadingParcelasPagas,
  getParcelas,
}) => {
  const { tema } = useContext(ContextoListaApartamentos);
  var resumoParcelasSelecionadas = useMemo(() => {
    return resumoParcelasSelecionadas;
  }, []);

  useEffect(() => {
    resumoParcelasSelecionadas = document.getElementById(
      'divResumoParcelasSelecionadas'
    );

    resumoParcelasSelecionadas.classList.add('showParcelasSelecionadas');
    resumoParcelasSelecionadas.innerHTML = mostraParcelas();
  }, [parcelasPagas]);

  function mostraParcelas() {
    return `
    <div class="centralized resumoParcelasSelecionadas__inner__totalPago" style={{width:"100%"}}>
    <div class="container">
    <p>Valor total pago: ${Format(parcelasPagas.totalRecebidas ?? '0,00')}</p>
    </div>
    </div>`;
  }

  if (loadingParcelasPagas) return <Spinner />;

  if (parcelasPagas.length == 0)
    return (
      <div
        style={{ width: '100%', textAlign: 'center' }}
        className='centralized-column'
      >
        <div
          style={{ width: '80%', textAlign: 'left' }}
          className='centralized'
        >
          <AlertIcon />{' '}
          <p style={{ marginLeft: '15px' }}>
            <b>
              No momento não há registros para exibir,{' '}
              <span
                onClick={() => {
                  getParcelas();
                }}
                style={{
                  color: '#0047BA',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                clique aqui para atualizar
              </span>{' '}
              ou entre em contato com nossa central de relacionamento para mais
              informações.
            </b>
          </p>
        </div>
      </div>
    );

  return (
    <>
      <Paginacao
        parcelas={parcelasPagas.recebidas}
        tema={tema}
        tipo={'pagas'}
      />
      <Alert />
    </>
  );
};

export default ParcelasPagas;
